<div mat-dialog-title>
  <span i18n>Мастер установки паза</span>

  <button mat-button class="mat-icon-button" [mat-dialog-close] aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="no-padding h-[70vh] flex flex-col">
  <mat-horizontal-stepper [linear]="true" #stepper>
    <mat-step #sideSelectStep [completed]="false" [editable]="false">
      <ng-template i18n matStepLabel>Выберите сторону</ng-template>
    </mat-step>

    <mat-step [completed]="false" [editable]="false" #adderStep>
      <ng-template i18n matStepLabel>Добавьте паз</ng-template>
    </mat-step>
  </mat-horizontal-stepper>

  <mat-divider> </mat-divider>

  <div class="flex-auto overflow-auto">
    <csl-countertop-schema
      [ngClass]="{ hidden: stepper.selectedIndex !== 0 }"
      (sideSelectorClick)="sideSelected($event.sideNumber)"
      #schema></csl-countertop-schema>

    <csl-slot-select
      [slots]="data.slots"
      [postCustomSlotsData]="data.postCustomSlotsData"
      [deleteCustomSlot]="data.deleteCustomSlot"
      [customSlotSchemas]="data.customSlotSchemas"
      [fullPanelThickness]="data.fullPanelThickness"
      (selectionChange)="selectionChanged($event.source.selected)"></csl-slot-select>
  </div>
</div>

<div mat-dialog-actions>
  <button
    i18n
    mat-raised-button
    color="accent"
    (click)="goToEdgeBandingSelect()"
    [disabled]="!sideNumbers.size"
    *ngIf="stepper.selectedIndex === 0"
    >Далее</button
  >

  <button
    i18n
    mat-raised-button
    color="accent"
    (click)="saveAndClose()"
    [disabled]="!selectedSlot"
    *ngIf="stepper.selectedIndex !== 0"
    >ОК</button
  >
  <button i18n mat-button [mat-dialog-close]>ОТМЕНА</button>
</div>
